<div class="rendelo-edit-page">
    <mat-card>
        <mat-card-header>
            <mat-card-title>{{ pageTitle }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="paciensForm" (ngSubmit)="onSubmit()">
                <!-- Személyes adatok -->
                <div class="form-section">
                    <h3>Személyes adatok</h3>
                    <div class="form-row">
                        <mat-form-field appearance="outline" class="form-field-small">
                            <mat-label>Előtag</mat-label>
                            <input matInput formControlName="elotag" placeholder="Dr., ifj., stb.">
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="form-field-medium">
                            <mat-label>Vezetéknév *</mat-label>
                            <input matInput formControlName="vezetekNev" required>
                            @if (paciensForm.get('vezetekNev')?.invalid && paciensForm.get('vezetekNev')?.touched) {
                                <mat-error>A vezetéknév megadása kötelező</mat-error>
                            }
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="form-field-medium">
                            <mat-label>Keresztnév 1 *</mat-label>
                            <input matInput formControlName="keresztNev1" required>
                            @if (paciensForm.get('keresztNev1')?.invalid && paciensForm.get('keresztNev1')?.touched) {
                                <mat-error>A keresztnév megadása kötelező</mat-error>
                            }
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field appearance="outline" class="form-field-medium">
                            <mat-label>Keresztnév 2</mat-label>
                            <input matInput formControlName="keresztNev2">
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="form-field-small">
                            <mat-label>Utótag</mat-label>
                            <input matInput formControlName="utoTag" placeholder="id., özv., stb.">
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="form-field-small">
                            <mat-label>Nem *</mat-label>
                            <mat-select formControlName="nem" required>
                                @for (option of nemOptions; track option.value) {
                                    <mat-option [value]="option.value">{{ option.label }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field appearance="outline" class="form-field-medium">
                            <mat-label>TAJ szám *</mat-label>
                            <input matInput formControlName="tajszam" required placeholder="123456789" maxlength="9">
                            @if (paciensForm.get('tajszam')?.hasError('required') && paciensForm.get('tajszam')?.touched) {
                                <mat-error>A TAJ szám megadása kötelező</mat-error>
                            }
                            @if (paciensForm.get('tajszam')?.hasError('pattern') && paciensForm.get('tajszam')?.touched) {
                                <mat-error>A TAJ szám 9 számjegyből áll</mat-error>
                            }
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="form-field-medium">
                            <mat-label>Születési dátum</mat-label>
                            <input matInput [matDatepicker]="picker" formControlName="szuletett">
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="form-field-medium">
                            <mat-label>Születési név</mat-label>
                            <input matInput formControlName="szuletesiNev">
                        </mat-form-field>
                    </div>
                </div>

                <!-- Telefonszámok -->
                <div class="form-section">
                    <div class="section-header">
                        <h3>Telefonszámok</h3>
                        <button mat-raised-button type="button" color="primary" (click)="addTelefon()">
                            <mat-icon>add</mat-icon>
                            Telefonszám hozzáadása
                        </button>
                    </div>
                    @if (telefonok.length === 0) {
                        <p class="no-items">Nincs telefonszám hozzáadva</p>
                    }
                    @for (telefon of telefonok.controls; track $index; let i = $index) {
                        <div class="array-item" [formGroup]="$any(telefon)">
                            <div class="form-row">
                                <mat-form-field appearance="outline" class="form-field-small">
                                    <mat-label>Ország</mat-label>
                                    <input matInput formControlName="orszagHivoszam" type="number" placeholder="36">
                                </mat-form-field>

                                <mat-form-field appearance="outline" class="form-field-small">
                                    <mat-label>Körzet</mat-label>
                                    <input matInput formControlName="korzet" type="number" placeholder="30">
                                </mat-form-field>

                                <mat-form-field appearance="outline" class="form-field-medium">
                                    <mat-label>Szám</mat-label>
                                    <input matInput formControlName="szam" type="number" placeholder="1234567">
                                </mat-form-field>

                                <mat-form-field appearance="outline" class="form-field-small">
                                    <mat-label>Mellék</mat-label>
                                    <input matInput formControlName="mellek" type="number">
                                </mat-form-field>

                                <button mat-icon-button type="button" color="warn" (click)="removeTelefon(i)" class="remove-button">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </div>
                    }
                </div>

                <!-- Email címek -->
                <div class="form-section">
                    <div class="section-header">
                        <h3>Email címek</h3>
                        <button mat-raised-button type="button" color="primary" (click)="addEmail()">
                            <mat-icon>add</mat-icon>
                            Email hozzáadása
                        </button>
                    </div>
                    @if (emailek.length === 0) {
                        <p class="no-items">Nincs email cím hozzáadva</p>
                    }
                    @for (email of emailek.controls; track $index; let i = $index) {
                        <div class="array-item" [formGroup]="$any(email)">
                            <div class="form-row">
                                <mat-form-field appearance="outline" class="form-field-large">
                                    <mat-label>Email cím</mat-label>
                                    <input matInput formControlName="emailCim" type="email" placeholder="pelda@email.hu">
                                    @if ($any(email).get('emailCim')?.hasError('email') && $any(email).get('emailCim')?.touched) {
                                        <mat-error>Érvénytelen email cím</mat-error>
                                    }
                                </mat-form-field>

                                <button mat-icon-button type="button" color="warn" (click)="removeEmail(i)" class="remove-button">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </div>
                    }
                </div>

                <!-- Action buttons -->
                <div class="form-actions">
                    <button mat-raised-button type="button" (click)="onCancel()">
                        Mégse
                    </button>
                    <button mat-raised-button color="primary" type="submit" [disabled]="loading || paciensForm.invalid">
                        @if (loading) {
                            <mat-spinner diameter="20"></mat-spinner>
                        } @else {
                            <ng-container>
                                <mat-icon>save</mat-icon>
                                Mentés
                            </ng-container>
                        }
                    </button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</div>
